import React from 'react';

export default class Card extends React.Component {
    constructor(props) {
        super(props)
    }

    renderMessage = () => {
        if(this.props.show()) {
            return (
                <div className={`card container `}>
                    {this.props.content}
                    {this.props.linkedCard ? (<a className={"greenColor"} href={"https://www.achs.cl/portal/ACHS-Corporativo/Paginas/afiliate-aqui_.aspx"} target="_blank">súmate a la ACHS</a>) : null}
                </div>
            )
        }
        return null
    }

    render (){
        return (
            <div>
                {
                    this.renderMessage()
                }
            </div>
        )
    }
}
